module.exports = __webpack_public_path__ + "static/media/inf_09og10.72293470.mp3";